import React from "react";
import {TwoToggle} from "../helpers/TwoToggle";

export class WorkModeForm extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state =
            {
                multiple_rounds: window.app.logboek.getSessionField('multiple_rounds'),
                multiple_instructions: window.app.logboek.getSessionField('multiple_instructions'),
                multiple_group_divisions: window.app.logboek.getSessionField('multiple_group_divisions'),

            }
        this.roundsClicked = this.roundsClicked.bind(this);
        this.divisionsClicked = this.divisionsClicked.bind(this);
        this.instructionsClicked = this.instructionsClicked.bind(this);
    }

    roundsClicked(p_selected)
    {
        this.setState(
            {
                multiple_rounds: p_selected,
            }
        )
        window.app.storeSessionFieldAndStoreLogboek("multiple_rounds", p_selected);
    }

    instructionsClicked(p_selected)
    {
        this.setState(
            {
                multiple_instructions: p_selected,
            }
        )
        window.app.storeSessionFieldAndStoreLogboek("multiple_instructions", p_selected);
    }

    divisionsClicked(p_selected)
    {
        this.setState(
            {
                multiple_group_divisions: p_selected,
            }
        )
        window.app.storeSessionFieldAndStoreLogboek("multiple_group_divisions", p_selected);
    }

    render()
    {
        return (
            <>

                <p><strong>Rondes:</strong><br/>
                <TwoToggle first_value='N' first_label='1 ronde' second_value='Y' second_label='Meerdere rondes' selected={this.state.multiple_rounds} callback={this.roundsClicked}/>
                </p>

                {this.state.multiple_rounds == 'Y' &&
                    (
                        <>
                            <p><strong>Nieuwe opdracht per ronde?</strong><br/>
                            <TwoToggle first_value='N' first_label='Nee' second_value='Y' second_label='Ja' selected={this.state.multiple_instructions} callback={this.instructionsClicked}/>

                            </p>
                            <p><strong>Nieuwe groepssamenstelling per ronde</strong><br/>
                            <TwoToggle first_value='N' first_label='Nee' second_value='Y' second_label='Ja' selected={this.state.multiple_group_divisions} callback={this.divisionsClicked}/>
                                </p>
                        </>


                    )}
            </>
        )
    }
}
